import {
  ConstructorExperienceActionTypes,
  ConstructorExperienceConstants,
  IsConstructorExperience,
} from 'actions/shared/constructorExperience'

export const constructoExperienceDefaultState = false

const constructoExperience = (
  state: IsConstructorExperience = constructoExperienceDefaultState,
  action: ConstructorExperienceActionTypes
): IsConstructorExperience => {
  switch (action.type) {
    case ConstructorExperienceConstants.SET_CONSTRUCTOR_EXPERIENCE:
      return action.payload

    default:
      return state
  }
}

export default constructoExperience
